var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"12","viewBox":"0 0 24 12"}},[_c('path',{attrs:{"fill":"var(--geist-background)","stroke-width":"1px","stroke":"var(--accents-2)","fill-rule":"evenodd","d":"M20 12l-8-8-12 12"}})])}
var staticRenderFns = []

export { render, staticRenderFns }